
<template>
    <div class="markmap">
        <MarkdownRenderer :content="markdownContent"></MarkdownRenderer>
    </div>
</template>


<script>
import MarkdownRenderer from '../components/MarkdownRenderer'


export default {
    components: { MarkdownRenderer },
    data() {
        return {
            markdownContent: '',
        }
    },
    mounted() {

        window['setMarkmapData'] = (msg) => {
            return this.setMarkmapData(msg);
        }
    },
    methods: {
        setMarkmapData(msg){
            let message = decodeURIComponent(msg);
            console.log(message);
            this.markdownContent = decodeURIComponent(msg);
            return "0";
        }
    },
}

</script>
<style>
.div{
    width: 20vh;
    height: 20vh;
    color: #000;
}
.markmap {
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>